import LegacySideBar from '@groovepages/gd-ui-kit/components/SideBarNew';
import { createSidebarAdapter } from '../../../groove-ui-kit-v2/src/vue2/account-adapter';
import AcademyMenu from '@groovepages/gd-ui-kit/components/AcademyMenu';
import FeedbackMenu from '@groovepages/gd-ui-kit/components/FeedbackMenu';

export const FEEDBACK_URL = 'https://feedback-portal.scaleplus.gg/issues?view=kanban';

const AcademyOnly = {
  name: 'DashboardAcademyOnly',
  render(h) {
    return h('div', { class: 'p-4 text-white' }, [
      h('a', {
        attrs: { href: this.$t('official_link_academy'), target: '_blank', rel: 'noopener noreferrer' },
      }, 'Groove Digital Academy'),
    ]);
  },
};

const FeedbackOnly = {
  name: 'DashboardFeedbackOnly',
  render(h) {
    return h('div', { class: 'p-4 text-white' }, [
      h('a', {
        attrs: { href: FEEDBACK_URL, target: '_blank', rel: 'noopener noreferrer' },
      }, 'Feedback'),
    ]);
  },
};

// Retain the legacy rail, app switcher, support and language controls. Only the
// two requested menu bodies and dashboard rail keyboard access are adapted.
export default {
  name: 'DashboardSideBar',
  extends: createSidebarAdapter(LegacySideBar),
  data() {
    const legacy = LegacySideBar.data.call(this);
    return {
      nativeMenus: legacy.nativeMenus.map(item => ({
        ...item,
        component: item.component === AcademyMenu
          ? AcademyOnly
          : item.component === FeedbackMenu ? FeedbackOnly : item.component,
      })),
    };
  },
  render(h) {
    const tree = LegacySideBar.render.call(this, h);
    const makeAccessible = node => {
      if (!node) return;
      const data = node.data;
      const tooltip = data && data.directives && data.directives.find(item => item.name === 'tooltip');
      if (node.tag === 'div' && tooltip && data.on && data.on.click) {
        data.attrs = { ...data.attrs, role: 'button', tabindex: '0', 'aria-label': tooltip.value.content };
        const previousKeydown = data.on.keydown;
        data.on.keydown = event => {
          if (previousKeydown) {
            const priorHandlers = Array.isArray(previousKeydown) ? previousKeydown : [previousKeydown];
            priorHandlers.forEach(handler => handler(event));
          }
          if (event.defaultPrevented) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const handlers = Array.isArray(data.on.click) ? data.on.click : [data.on.click];
            handlers.forEach(handler => handler(event));
          }
        };
      }
      (node.children || []).forEach(makeAccessible);
    };
    makeAccessible(tree);
    return tree;
  },
};
